import React, { useEffect, useState } from 'react';
import { Table, Descriptions, message, Input, Popconfirm } from 'antd';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { getWingopsUsers, removeUserFromOrganization } from '../api';

const { Search } = Input;

const UsersWrapper = styled.div`
	width: 100%;
	height: 100%;
`;

const AdditionalInfoWrapper = styled.div`
	padding: 0px 24px;
`;

const filterUsers = (users: any, searchWord: string) => {
	if (!searchWord) {
		return users;
	}

	return users.filter(
		(a: any) =>
			`${a.name}`.toLowerCase().includes(searchWord.toLowerCase()) ||
			`${a.email}`.toLowerCase().includes(searchWord.toLowerCase()) ||
			`${a.id}`.toLowerCase().includes(searchWord.toLowerCase())
	);
};

function WingopsUsers(props: any) {
	const [users, setUsers]: any = useState([]);
	const [searchValue, setSearchValue]: any = useState('');
	const [loading, setloading]: any = useState(false);
	const [saving, setSaving]: any = useState(false);

	async function fetchUsers() {
		setloading(true);
		const resp = await getWingopsUsers().catch((err) => message.error('Something went wrong, cannot get users'));

		if (resp && resp.length) {
			setUsers(resp);
		}

		setloading(false);
	}

	useEffect(() => {
		fetchUsers();
	}, []);

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: 'Organizations',
			dataIndex: 'organizations_count',
			width: 100,
			key: 'organizations_count',
			render: (text: string, record: any) => record.organizations.length,
		},
	];

	async function onRemoveUser(userId: string, orgId: string) {
		try {
			setSaving(true);
			await removeUserFromOrganization(userId, orgId);

			await fetchUsers();
			setSaving(false);
		} catch (err) {
			setSaving(false);
			message.error('Something went wrong, cannot remove user from that organization');
		}
	}

	const onSearch = (ev: any) => setSearchValue(ev.target.value);

	return (
		<UsersWrapper>
			<Search
				placeholder="Search users"
				onChange={onSearch}
				style={{ width: 200, marginBottom: 12, float: 'right' }}
			/>
			<Table
				id="main"
				expandedRowRender={(record: any) => {
					return (
						<AdditionalInfoWrapper>
							<Descriptions column={1} title="Organizations" size="small">
								{record.organizations.map((org: any) => {
									return (
										<Descriptions.Item key={org.id} label={org.name}>
											<Popconfirm
												title="Do you really want to remove from organization?"
												onConfirm={() => onRemoveUser(record.id, org.id)}
											>
												<a>Remove</a>
											</Popconfirm>
										</Descriptions.Item>
									);
								})}
							</Descriptions>
						</AdditionalInfoWrapper>
					);
				}}
				pagination={{
					size: 'default',
					pageSize: 40,
					showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
				}}
				locale={{
					emptyText: 'No organizations found',
				}}
				style={{ paddingBottom: 24 }}
				loading={loading}
				rowKey={(record: any) => record.id}
				columns={columns}
				dataSource={filterUsers(users, searchValue)}
			/>
		</UsersWrapper>
	);
}

export default withRouter(WingopsUsers);
